/** @format */

import React, { Fragment, useEffect, useState } from "react";
import TableForm from "./tableForm";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import logoHead from "./logo/cder_logo.png";

import FormApp1 from "./formApp_1";
import FormApp2 from "./formApp_2";
import FormApp3 from "./formApp_3";
import FormApp4 from "./formApp_4";
import FormApp5 from "./formApp_5";
import FormApp6 from "./formApp_6";
import FormApp7 from "./formApp_7";
import FormApp8 from "./formApp_8";
import FormApp9 from "./formApp_9";
import FormApp10 from "./formApp_10";

export const ApprovedRequests = ({ setAuth }) => {
  const [name, setName] = useState("");
  const [empId, setEmpId] = useState(null);
  const [empLvl, setEmpLvl] = useState(null);
  const [empRole, setEmpRole] = useState(null);
  const [app1, setApp1] = useState(null);
  const [app2, setApp2] = useState(null);
  const [app3, setApp3] = useState(null);
  const [app4, setApp4] = useState(null);
  const [app5, setApp5] = useState(null);
  const [app6, setApp6] = useState(null);
  const [app7, setApp7] = useState(null);
  const [app8, setApp8] = useState(null);

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setEmpId(parsRes.emp_id);
      setEmpLvl(parsRes.emp_level);
      setEmpRole(parsRes.emp_role);
      setApp1(parsRes.approver_1);
      setApp2(parsRes.approver_2);
      setApp3(parsRes.approver_3);
      setApp4(parsRes.approver_4);
      setApp5(parsRes.approver_5);
      setApp6(parsRes.approver_6);
      setApp7(parsRes.approver_7);
      setApp8(parsRes.approver_8);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [requests, setRequests] = useState([]);
  // const [requestID, setRequestID] = useState(null)
  const [itemsTable, setItemsTable] = useState([]);

  const [approveRequestData, setApproveRequestData] = useState({
    reqIDRec: null,
    appIdRec: null,
    appTitleRec: null,
    empIdRec: null,
    empNameRec: null,
    reqTimeRec: null,
    appTimeRec: null,
  });

  const getRequests = async () => {
    // Get all current requests by the user
    const approvedRequests = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approved_requests`
    );
    const parseRes = await approvedRequests.json();
    console.log(parseRes);
    const sortedRequests = parseRes.sort((a, b) =>
      a.req_date > b.req_date ? 1 : -1
    );
    setRequests(sortedRequests);
    // setRequests(parseRes);
    // sort requests by the req_date column

    // console.log(sortedRequests);

    // console.log(parseRes);
  };
  // console.log(requests);
  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  const [docs, setDocs] = useState([]);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/documents`
    );
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
  };
  const [currentUserAppState, setCurrentUserAppState] = useState(null);
  const getCurrentUserAppState = () => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].role_id === empRole) {
        setCurrentUserAppState(approvers[i].app_id);
      }
    }
  };

  const [approvalRecords, setApprovalRecords] = useState([]);
  const fetchApprovalRecords = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approval_records`
    );
    const data = await response.json();
    setApprovalRecords(data);
  };

  const [currentApproverTitle, setCurrentApproverTitle] = useState(null);
  const getCurrentApproverTitle = () => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].role_id === empRole) {
        setCurrentApproverTitle(approvers[i].app_title);
      }
    }
  };

  const [filteredDocs, setFilteredDocs] = useState([]);
  const filterDocs = () => {
    if (docs.length !== 0) {
      const filtered = docs.filter((doc) =>
        [
          "approver_1",
          "approver_2",
          "approver_3",
          "approver_4",
          "approver_5",
          "approver_6",
          "approver_7",
          "approver_8",
        ].some((approver) => doc[approver] === currentUserAppState)
      );
      setFilteredDocs(filtered);
    }
  };

  const [displayedRequests, setDisplayedRequests] = useState([]);

  const filterRequests = () => {
    const docTypeIds = new Set(filteredDocs.map((doc) => doc.doc_type_id));
    const filteredRequests = requests.filter((request) =>
      docTypeIds.has(request.doc_type)
    );
    setDisplayedRequests(filteredRequests);
  };
  // console.log(displayedRequests);
  // const [requestData, setRequestData] = useState([]);
  // const [itemsTableData, setItemsTableData] = useState([]);
  const [selectedReqID, setSelectedReqID] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);

  const handleRequestSelect = (reqID, docTypeID) => {
    setSelectedReqID(reqID);
    setSelectedForm(docTypeID);
  };
  const [appReqStatus, setAppReqStatus] = useState({
    req_id: null,
    approver: null,
  });
  const updateReqAppStatus = () => {
    if (filteredDocs.length > 0) {
      const currDoc = filteredDocs.filter(
        (filter) => filter.doc_type_id === selectedForm
      );
      const currDocArray = Object.entries(currDoc[0]);
      let returned = null;

      for (let i = 0; i < currDocArray.length; i++) {
        const key = currDocArray[i][0];
        const value = currDocArray[i][1];

        if (value === currentUserAppState) {
          returned = value;
          setAppReqStatus({
            ...appReqStatus,
            approver: key,
            req_id: selectedReqID,
          });
        }
      }
    }
  };

  // console.log(appReqStatus);

  useEffect(() => {
    getName();
    fetchApprovalRecords();
  }, []);

  useEffect(() => {
    getName();
    updateReqAppStatus();
  }, [selectedForm]);

  useEffect(() => {
    fetchAppro();
  }, [name]);

  useEffect(() => {
    fetchDocs();
    getCurrentApproverTitle();
  }, [approvers]);

  useEffect(() => {
    getRequests();
  }, [docs]);

  useEffect(() => {
    getCurrentUserAppState();
  }, [requests]);

  useEffect(() => {
    filterDocs();
  }, [currentUserAppState]);

  useEffect(() => {
    filterRequests();
  }, [filteredDocs]);

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setAuth(false);
    toast("Déconnecté");
  };

  const [requestDate, setRequestDate] = useState(null);
  const getRequestDate = () => {
    for (let i = 0; i < displayedRequests.length; i++) {
      if (displayedRequests[i].req_id == selectedReqID) {
        setRequestDate(displayedRequests[i].req_date);
      }
    }
  };

  useEffect(() => {
    getRequestDate();
  }, [selectedReqID]);

  useEffect(() => {
    setApproveRequestData({ ...approveRequestData, reqIDRec: selectedReqID });
  }, [selectedReqID]);

  useEffect(() => {
    setApproveRequestData({
      ...approveRequestData,
      appIdRec: currentUserAppState,
    });
  }, [currentUserAppState]);

  const [currentDate, setCurrentDate] = useState(new Date());
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setApproveRequestData({
      ...approveRequestData,
      appTimeRec: currentDate,
      empIdRec: empId,
      empNameRec: name,
      reqTimeRec: requestDate,
      appTitleRec: currentApproverTitle,
    });
  }, [currentDate]);

  const [approveEvent, setApproveEvent] = useState(false);

  // const reqAppUpdate = await fetch("http:`{process.env.REACT_APP_BACKEND_URL}/updateRequest", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         token: localStorage.token,
  //       },
  //       body: JSON.stringify(appReqStatus),
  //     });

  console.log(requests);

  return (
    <Fragment>
      <div className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            Popular Democratic Republic of Algeria Ministry of Higher Education
            & Scienth1ific Research General Directorate for Scientific Research
            and Technological Development
          </p>
        </div>
        <div className="banner-text-2">
          <h5>Renewable Energy Development Center</h5>
        </div>
      </div>

      <div id="navbar" className="topnav">
        <Link to="/dashboard">Accueil</Link>

        <Link to="/request_submit">Faire une demande</Link>
        <button className="btn dash-logout" onClick={(e) => logout(e)}>
          Logout
        </button>

        <div className="dash-welcome">
          <span>{name}</span>
        </div>
      </div>

      <div className="request-approve-container">
        <div className="requests-display">
          <table className="table table-hover ">
            <thead className="table-primary	">
              <tr>
                <th>Tittre</th>

                <th>Date de la demande</th>
              </tr>
            </thead>
            <tbody>
              {displayedRequests.map((request) => (
                <tr
                  onClick={(e) =>
                    handleRequestSelect(request.req_id, request.doc_type)
                  }
                  className="table-row"
                  key={request.req_id}
                >
                  <td>{request.doc_tittle}</td>
                  <td>
                    {new Date(request.req_date).toLocaleDateString("en-GB")}
                    <br />
                    {new Date(request.req_date).toLocaleTimeString("en-GB")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedForm && (
          <div className="document">
            {selectedForm === 1 && (
              <FormApp1
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 2 && (
              <FormApp2
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 3 && (
              <FormApp3
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 4 && (
              <FormApp4
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 5 && (
              <FormApp5
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 6 && (
              <FormApp6
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 7 && (
              <FormApp7
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 8 && (
              <FormApp8
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 9 && (
              <FormApp9
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
            {selectedForm === 10 && (
              <FormApp10
                reqID={selectedReqID}
                empId={empId}
                approveEvent={approveEvent}
              />
            )}
          </div>
        )}
      </div>

      <ToastContainer />
    </Fragment>
  );
};
